import React, { useContext } from "react"
import { useMarina } from "src/contexts/MarinaContext"

import Form from "src/components/Form"
import Heading from "src/components/Heading"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

import { WizardContext } from "../../../WizardContextProvider"
import PreservedRateModalButton from "./PreservedRateModalButton"
import PriceEstimateHelpText from "./PriceEstimateHelpText"

const SimplePriceEstimate = () => {
  const {
    isLoadingPriceEstimate,
    priceEstimateData,
    getPriceEstimateError,
    priceEstimateError,
  } = useContext(WizardContext)

  const { presentmentCurrency, currencySymbol } = useMarina()

  const formatTotalPrice = () => {
    if (getPriceEstimateError) {
      return `${currencySymbol}-.--`
    }

    if (priceEstimateData) {
      return priceEstimateData.total_price === "--"
        ? `${currencySymbol}-.--`
        : formatCurrencyFromMinorUnits({
            amount: priceEstimateData.total_price,
            currency: presentmentCurrency,
          })
    }

    return `${currencySymbol}-.--`
  }

  const renderTotalPrice = () => (
    <div className="text-3xl font-semibold leading-9 text-teal-700">
      {formatTotalPrice()}
    </div>
  )

  const renderLoadingSpinner = () => (
    <span
      data-testid="trw-simple-price-estimate-loading"
      className="fa-solid fa-spinner-third fa-spin text-2xl leading-9 text-gray-600"
    />
  )

  const renderErrorMessage = () => {
    return getPriceEstimateError && !isLoadingPriceEstimate ? (
      <Form.Error>
        {priceEstimateError?.message || "Error fetching price estimate"}
      </Form.Error>
    ) : null
  }

  return (
    <div className="rounded bg-gray-100 p-4">
      <div className="flex flex-col items-center space-y-4 py-6">
        {isLoadingPriceEstimate ? renderLoadingSpinner() : renderTotalPrice()}
        <Heading.SectionHeader>Price Estimate</Heading.SectionHeader>
        <PriceEstimateHelpText />
        {renderErrorMessage()}
      </div>
      <PreservedRateModalButton />
    </div>
  )
}

export default SimplePriceEstimate
